export const stepList = [
  { num: 1, word: '基本信息' },
  { num: 2, word: '合同条款' },
  { num: 3, word: '物业交割' },
  { num: 4, word: '其他信息' }
]
export const lineNumber = [1, 2, 3, 4, 5, 6]
// 企业合同租期时长 枚举
export const rentTime = [
  {'id': '12', 'name': '一年'},
  {'id': '1', 'name': '1个月'},
  {'id': '2', 'name': '2个月'},
  {'id': '3', 'name': '3个月'},
  {'id': '4', 'name': '4个月'},
  {'id': '5', 'name': '5个月'},
  {'id': '6', 'name': '半年'},
  {'id': '7', 'name': '7个月'},
  {'id': '8', 'name': '8个月'},
  {'id': '9', 'name': '9个月'},
  {'id': '10', 'name': '10个月'},
  {'id': '11', 'name': '11个月'},
]
// 企业合同 支付周期枚举
export const payCycle = [
  {
    'id': 'ONEMON',
    'name': '月付'
  },
  {
    'id': 'THREEMON',
    'name': '季付'
  },
  {
    'id': 'SIXMON',
    'name': '半年付'
  },
  {
    'id': 'TWELVEMON',
    'name': '年付'
  },
]
export const houseList = [
  {
    houseName: '71栋301',
    ruleRentMoney: 1900,
    firstDiscount: '1000',
    earnest: '1000'
  },
  {
    houseName: '72栋201',
    ruleRentMoney: 1900,
    firstDiscount: '1000',
    earnest: '1000'
  },
]
export const houseListNum = [
  {
    houseName: '71栋301室',
    rentMoney: '1800元/月',
    rentStatus: '已预订'
  },
  {
    houseName: '71栋302室',
    rentMoney: '1400元/月',
    rentStatus: '已预订'
  },
  {
    houseName: '71栋303室',
    rentMoney: '1800元/月',
    rentStatus: '空置'
  },
  {
    houseName: '71栋304室',
    rentMoney: '1800元/月',
    rentStatus: '已预订'
  },
  {
    houseName: '71栋305室',
    rentMoney: '1800元/月',
    rentStatus: '空置'
  },
  {
    houseName: '71栋306室',
    rentMoney: '1800元/月',
    rentStatus: '空置'
  },
  {
    houseName: '71栋307室',
    rentMoney: '1800元/月',
    rentStatus: '空置'
  },
  {
    houseName: '71栋308室',
    rentMoney: '1800元/月',
    rentStatus: '已预订'
  },
  {
    houseName: '71栋309室',
    rentMoney: '1800元/月',
    rentStatus: '已预订'
  },
]
export const houseSpaceStatus = (val) => {
  let dict = {
    RENTABLE: '空置',
    RESERVED: '已预订'
  }
  return dict[val] || val
}
export const options2 = [// 支付周期判断
  {
    id: 'ONEPAY',
    name: '一次付清',
    disabled: false
  },
  {
    id: 'ONEMON',
    name: '月付',
    disabled: false
  }, {
    id: 'THREEMON',
    name: '季付',
    disabled: false
  },
  {
    id: 'SIXMON',
    name: '半年付',
    disabled: false
  }, {
    id: 'TWELVEMON',
    name: '年付',
    disabled: false
  }
]
// 租客来源
export const source = [
  {
    name: '个人中介',
    id: 'MEDI'
  },
  {
    name: '公司中介',
    id: 'CMEDI'
  },
  {
    name: '租客介绍',
    id: 'INTRO'
  },
  {
    name: '58同城',
    id: 'CITY58'
  },
  {
    name: '赶集网',
    id: 'MANET'
  },
  {
    name: '豆瓣',
    id: 'DBNET'
  },
  {
    name: '春眠',
    id: 'SPNET'
  },
  {
    name: '嗨住',
    id: 'HZNET'
  },
  {
    name: '微信公众号',
    id: 'WECHAT'
  },
  {
    name: '19楼',
    id: 'FLOOR19'
  },
  {
    name: '其他',
    id: 'OTHER'
  },
  {
    name: '地推',
    id: 'DTBET'
  },
  {
    name: '甲方结转',
    id: 'PATYJ'
  },
  {
    name: '抖音',
    id: 'DOUYIN'
  }
]




// WEBPACK FOOTER //
// ./src/components/forms/BusinessContractForm/enum.js